import { render, staticRenderFns } from "./ProductSportsPage.vue?vue&type=template&id=e7aa427a&scoped=true&"
import script from "./ProductSportsPage.vue?vue&type=script&lang=js&"
export * from "./ProductSportsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7aa427a",
  null
  
)

export default component.exports